import type { Category, Company } from './Establishment'
import type { EstablishmentReviews, MarketplaceMarketingEstablishmentCity, Media } from './MarketplaceEstablishment'

class Establishment {
  id: string
  slug: string
  title: string
  reviews: EstablishmentReviews
  categories: Category[]
  media: Media
  city: MarketplaceMarketingEstablishmentCity
  company: Company

  constructor(establishment: any) {
    this.id = establishment.id
    this.slug = establishment.slug
    this.title = establishment.title
    this.reviews = {
      averageRating: establishment.reviews.average_rating,
      count: establishment.reviews.count,
    }
    this.categories = establishment.categories.map((category: any) => ({
      id: category.id,
      name: category.name,
    }))
    this.media = {
      images: {
        avatar: {
          large: {
            url: establishment.media.images.avatar.large.url,
          },
          medium: {
            url: establishment.media.images.avatar.large.url,
          },
          small: {
            url: establishment.media.images.avatar.large.url,
          },
        },
        cover: {
          large: {
            url: establishment.media.images.cover.large.url,
          },
          medium: {
            url: establishment.media.images.cover.medium.url,
          },
          small: {
            url: establishment.media.images.cover.small.url,
          },
        },
      },
    }
    this.city = {
      id: establishment.city.id,
      name: establishment.city.name,
      slug: establishment.city.slug,
      country: establishment.city.country.code,
    }
    this.company = {
      id: establishment.company.id,
      name: establishment.company.name,
    }
  }
}

class City {
  id: number
  name: string
  slug: string

  constructor(city: any) {
    this.id = city.id
    this.name = city.name
    this.slug = city.slug
  }
}

class MarketingPage {
  id: number
  title: string
  subtitle: string
  slug: string
  content: any
  hideAddressInput: boolean
  meta: any
  category: any | null = null
  city: City | null = null
  establishments: Establishment[]
  media: Media

  constructor(marketingPage: any) {
    this.id = marketingPage.id
    this.title = marketingPage.attributes.title
    this.subtitle = marketingPage.attributes.subtitle
    this.slug = marketingPage.attributes.slug

    this.content = marketingPage.attributes.content
    this.hideAddressInput = marketingPage.attributes.hide_address_input

    this.meta = {
      title: marketingPage.attributes.meta.title,
      description: marketingPage.attributes.meta.description,
    }

    if (marketingPage.relationships.category !== null) {
      this.category = {
        id: marketingPage.relationships.category.id,
        ...marketingPage.relationships.category.attributes,
      }
    }

    if (marketingPage.relationships.city !== null) {
      this.city = new City({
        ...marketingPage.relationships.city.id,
        ...marketingPage.relationships.city.attributes,
      })
    }

    this.establishments = marketingPage.relationships.establishments.map((establishment: any) => new Establishment(establishment))

    this.media = {
      images: {
        // avatar: {
        //   large: {
        //     url: marketingPage.relationships.media.images.avatar.large.url,
        //   },
        //   medium: {
        //     url: marketingPage.relationships.media.images.avatar.large.url,
        //   },
        //   small: {
        //     url: marketingPage.relationships.media.images.avatar.large.url,
        //   },
        // },
        cover: {
          large: {
            url: marketingPage.relationships.media.images.cover.large.url,
          },
          medium: {
            url: marketingPage.relationships.media.images.cover.medium.url,
          },
          small: {
            url: marketingPage.relationships.media.images.cover.small.url,
          },
        },
      },
    }
  }
}

export {
  MarketingPage,
  Establishment,
}
